import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import Box from "../../lib/appfuse-react/component/Box";
import Paper from "../../lib/appfuse-react/component/Paper";
import CircularProgress from "../../lib/appfuse-react/component/CircularProgress";
import {
    Checkbox, Divider,
    FormControlLabel,
    FormGroup,
    Step,
    StepLabel,
    Stepper,
    Typography
} from "@material-ui/core";
import i18n from "../../lib/appfuse-react/core/i18n";
import Toolbar from "../../component/Toolbar";
import Space from "../../lib/appfuse-react/component/Space";
import Button from "../../lib/appfuse-react/component/Button";
import enrollmentService from "../../service/enrollment/enrollmentService";
import {makeStyles} from "@material-ui/core/styles";
import UserEvent from "../../lib/appfuse-react/core/UserEvent";
import DataTable, {DataColumn} from "../../lib/appfuse-react/component/DataTable";
import {ContactPersonAndInvoiceInformationContent, RegistrationInformationContent} from "../../component/Enrollment";
import {withDesktop} from "../../layout/Desktop";
import {useDispatch, useSelector} from "../../store";
import {selectClassInfo, setClassInfo} from "../../reducer/enrollment/enrollmentReducer";
import code from "../../lib/appfuse-react/core/code";
import memberService from "../../service/member/memberService";
import {selectUserInfo} from "../../reducer/iam/authReducer";
import {selectCounty, setCounty} from "../../reducer/util/utilReducer";
import lang from "../../lib/appfuse-react/core/lang";
import utilService from "../../service/util/utilService";
import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import valueChange from "../../component/Judge/ValueChange";
import RichText from "../../lib/appfuse-react/component/RichText";
import time from "../../lib/appfuse-react/core/time";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";

const useStyles = makeStyles((theme) => ({
    pre: {
        whiteSpace: 'pre-wrap'
    }
}));

// 個人資料提供同意書 報名資料 聯絡人及發票資料 候補梯次
const STEPS = ['Release of Personal Information Agreement', 'Registration Information', 'Contact Person and Invoice Information', 'Alternate Echelon'];

const validateData = [
    [],
    ['chineseName', 'englishName', 'mobilePhone', 'phone', 'mailingAddress', 'applyCredit', 'idNo', 'ourAccreditedLaboratory', 'laboratoryNo',
        'certificateNo17025', 'signingMemorandum', 'certifiedDocument', 'industry', 'field'],
    ['contactPerson', 'contactEmail', 'contactMobilePhone', 'invoiceIdentity', 'notifyContactForCourseEmail', 'company', 'department', 'invoiceTitle', 'invoiceType', 'taxIdNo'],
    ['waitingClasses']
];

function EnrollmentApplet() {
    const history = useHistory();
    const dispatch = useDispatch();
    const prompt = usePrompt();
    const {classId, type} = useParams();
    const [ready, setReady] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [agreement, setAgreement] = useState({});
    const [allWaiting, setAllWaiting] = useState([]);
    const classInfo = useSelector(selectClassInfo);
    const userInfo = useSelector(selectUserInfo);
    const county = useSelector(selectCounty);
    const isEnrollment = type==='enrollment';
    const steps = isEnrollment? STEPS.slice(0, 3):STEPS;
    const component = isEnrollment? Enrollment:Waiting;

    const responsive = useResponsive();
    const isMobile = responsive.isSmallScreen();

    const [value, setValue] = useState({});

    const {courseTitleCode = ""} = classInfo;
    const categoryMemberOfSigningMemorandum = ['MM', 'MH', 'MG', 'TL', 'CU', 'POCT'];

    useEffect(() => {
        (async ()=> {

            if(classId===':classId' || type===':type') {
                history.push('/courseAnnouncement');
            }

            await code.assert('applyCredit', 'invoiceType');

            const agreement = await enrollmentService.findAgreement();
            setAgreement(agreement);

            const {href} = userInfo;
            const info = await memberService.getInfo(href);
            setValue({...info, courseClass:classId});

            if(!isEnrollment) {
                const allWaiting = await enrollmentService.allWaiting(classId);
                setAllWaiting(allWaiting);
            }

            if(lang.isEmpty(county)) {
                const county = await utilService.findCounty();
                dispatch(setCounty(county));
            }

            setReady(true);
        })();
    }, []);

    const handleChange = (event) => {
        const {change} = event;
        setValue(change);
    };

    const getValidateData = () => {
        const name = validateData[activeStep];
        if (courseTitleCode && categoryMemberOfSigningMemorandum.includes(courseTitleCode) && activeStep === 1) {
            name.push('memberOfSignedMemorandum');
        }
        let result = {courseCode:classInfo.code};
        name.forEach(key => {result[key] = valueChange.getValue(value[key], null)});
        return result;
    };
    const handleNext = async () => {
        try {
            if(activeStep!==0) {
                if(isEnrollment) await enrollmentService.validate(getValidateData());
                else await enrollmentService.validateWaiting(getValidateData());
            }
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } catch (e) {
            const dictionary = {contactPerson:'Name', contactEmail:'Email', contactMobilePhone:'Mobile Phone'};
            prompt.alert(e, {title:'Invalid input.', dictionary});
        }
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleEnroll = async () => {
        try {
            await enrollmentService.validate(getValidateData());
            await enrollmentService.enrollment(value);
            prompt.success('Enrollment Successfully.');
            dispatch(setClassInfo({}));
            history.push('/courseAnnouncement');
        } catch (e) {
            prompt.alert(e, {title:'Failed to enrollment.'});
        }
    };
    const handleWaiting = async () => {
        try {
            await enrollmentService.validateWaiting(getValidateData());
            await enrollmentService.waiting(value);
            prompt.success('Waiting Successfully.');
            dispatch(setClassInfo({}));
            history.push('/courseAnnouncement');
        } catch (e) {
            prompt.alert(e, {title:'Failed to waiting.'});
        }
    };

    return (
        <Box display='flex' fullWidth fullHeight>
            <Paper fullWidth fullHeight square variant='outlined'>
                <CircularProgress value={ready} fullWidth fullHeight>
                    <Box fullHeight fullWidth display='flex' flexDirection='column' paddingY={2} paddingX={4} overflow='hidden'>
                        <Toolbar>
                            <Typography>{`${classInfo.code} / ${classInfo.courseTitle} / ${code.translate('enrollmentType', type)}`}</Typography>
                        </Toolbar>
                        { frame(component)({course:classInfo, agreement, value, steps, onChange:handleChange, onEnroll:handleEnroll, onWaiting:handleWaiting,
                            activeStep, onNext:handleNext, onBack:handleBack, allWaiting, isMobile}) }
                    </Box>
                </CircularProgress>
            </Paper>
        </Box>
    );
}

const frame = WrapperComponent => (props) => {
    const {course, agreement, value, steps, activeStep, allWaiting, isMobile = false} = props;

    const width = isMobile? '100%':'82%';

    return (
        <Box fullHeight fullWidth display='flex' overflow='hidden'>
            <Box width={width} fullHeight paddingX={2} paddingBottom={2} overflow='hidden'>
                <WrapperComponent value={value} course={course} agreement={agreement} activeStep={activeStep} allWaiting={allWaiting}
                                  onNext={props.onNext} onBack={props.onBack} onEnroll={props.onEnroll} onWaiting={props.onWaiting} onChange={props.onChange}/>
            </Box>
            {!isMobile && <Box width='18%' fullHeight overflow='auto'>
                <EnrollmentStepper activeStep={activeStep} steps={steps}/>
            </Box>}
        </Box>
    );
};

function Enrollment(props) {
    const {course, agreement, value, activeStep} = props;

    if(activeStep===0) {
        return <ReleaseOfPersonalInformationAgreement agreement={agreement} value={value} onChange={props.onChange} onNext={props.onNext}/>
    } else if(activeStep===1) {
        return <RegistrationInformation course={course} value={value} onBack={props.onBack} onNext={props.onNext} onChange={props.onChange}/>
    } else if(activeStep===2) {
        return <ContactPersonAndInvoiceInformation value={value} onBack={props.onBack} onComplete={props.onEnroll} onChange={props.onChange}/>
    }
}

function Waiting(props) {
    const {course, agreement, value, activeStep, allWaiting} = props;

    if(activeStep===0) {
        return <ReleaseOfPersonalInformationAgreement agreement={agreement} value={value} onChange={props.onChange} onNext={props.onNext}/>
    } else if(activeStep===1) {
        return <RegistrationInformation course={course} value={value} onBack={props.onBack} onNext={props.onNext} onChange={props.onChange}/>
    } else if(activeStep===2) {
        return <ContactPersonAndInvoiceInformation value={value} onBack={props.onBack} onNext={props.onNext} onChange={props.onChange}/>
    } else if(activeStep===3) {
        return <AlternateEchelon value={value} allWaiting={allWaiting} onBack={props.onBack} onComplete={props.onWaiting} onChange={props.onChange}/>
    }
}

function ReleaseOfPersonalInformationAgreement(props) {
    const {agreement} = props;
    const [value, setValue] = useState(false);
    const history = useHistory();
    const classes = useStyles();

    const handleClose = () => {
        history.push('/courseAnnouncement');
    };

    const handleChange = (event) => {
        setValue(event.target.checked);
    };

    return (
        <Box fullHeight fullWidth display='flex' flexDirection='column'>
            <Box fullWidth paddingY={1}>
                <Typography variant='h5'>{i18n.translate('Release of Personal Information Agreement(For Educational Training)')}</Typography>
            </Box>
            <Box fullWidth padding={1} overflow='auto' border='1px solid black'>
                <RichText value={agreement} fullWidth disabled/>
            </Box>
            <Box fullWidth paddingY={1}>
                <Typography className={classes.pre}>{i18n.translate('Agreement Waring')}</Typography>
            </Box>
            <FormGroup row>
                <FormControlLabel value={value} control={<Checkbox/>} label={i18n.translate('Agreement 1')} onChange={handleChange}/>
            </FormGroup>
            <Space spacing={2} vertical/>
            <Box display="flex" justifyContent="space-between" paddingTop={1}>
                <Button text="Close" color="secondary" onClick={handleClose} />
                <Button text="Next" variant="contained" color="primary" onClick={props.onNext} disabled={!value} />
            </Box>
        </Box>
    );
}

function RegistrationInformation(props) {
    const {course={}, value={}} = props;

    return (
        <Box fullHeight fullWidth display='flex' flexDirection='column'>
            {/*報名資料內容*/}
            <RegistrationInformationContent course={course} change={value} onChange={props.onChange}/>
            <Space spacing={2} vertical />
            <Box display="flex" justifyContent="space-between" paddingTop={1}>
                <Button text="Back" color="secondary" onClick={props.onBack} />
                <Button text="Next" variant="contained" color="primary" onClick={props.onNext} />
            </Box>
        </Box>
    );
}

function ContactPersonAndInvoiceInformation(props) {
    const {value={}} = props;

    return (
        <Box fullHeight fullWidth display='flex' flexDirection='column'>
            {/*聯絡人及發票資料內容*/}
            <ContactPersonAndInvoiceInformationContent change={value} onChange={props.onChange}/>
            <Space spacing={2} vertical />
            <Box display="flex" justifyContent="space-between" paddingTop={1}>
                <Button text="Back" color="secondary" onClick={props.onBack} />
                { props.onNext && <Button text="Next" variant="contained" color="primary" onClick={props.onNext} /> }
                { props.onComplete && <Button text="Complete" variant="contained" color="primary" onClick={props.onComplete} /> }
            </Box>
        </Box>
    );
}

function AlternateEchelon(props) {
    const {value={}, allWaiting=[]} = props;
    const responsive = useResponsive();
    const isMobile = responsive.isMediumScreen() || responsive.isSmallScreen();

    const renderClassDate = (data) => {
        const {courseDateStart, courseDateEnd} = data;
        if(courseDateStart && courseDateEnd) {
            return <Typography>{`${time.format(courseDateStart, 'YYYY/MM/DD')} ~ ${time.format(courseDateEnd, 'YYYY/MM/DD')}`}</Typography>;
        } else {
            return <Typography>{''}</Typography>;
        }
    };

    const handleSelect = (event) => {
        const {selection} = event;
        props.onChange(new UserEvent({change: {...value, waitingClasses:selection}}))
    };

    const handleClickSelect = (uuid) => {
        const selection = value.waitingClasses || [];
        const index = selection.indexOf(uuid);
        if(index>=0) {
            selection.splice(index, 1);
        } else {
            selection.push(uuid);
        }
        props.onChange(new UserEvent({change: {...value, waitingClasses:selection}}));
    };

    return (
        <Box fullHeight fullWidth display='flex' flexDirection='column'>
            <Box fullWidth padding={1} overflow='hidden' display='flex' flexDirection='column'>
                <Box fullWidth paddingY={2}>
                    <Typography variant='h5'>{i18n.translate('Alternate Echelon')}</Typography>
                </Box>
                { isMobile ?
                    <Box overflow={'auto'}>
                        {
                            allWaiting.map((data, index) => (
                                <React.Fragment>
                                    <EnrollmentMobileBox key={index} {...data} selection={value.waitingClasses} onClick={() => {handleClickSelect(data.uuid)}} />
                                    <Divider/>
                                </React.Fragment>
                            ))
                        }
                    </Box>
                    :
                    <DataTable data={allWaiting} selection={value.waitingClasses} onSelect={handleSelect} checkbox rowId='uuid' stickyHeader>
                        <DataColumn accessor='code' label='Course No'/>
                        <DataColumn accessor={renderClassDate} label='Class Date'/>
                        <DataColumn accessor='location' label='Class Location' formatter={data => code.translate('classLocation', data)}/>
                    </DataTable>
                }
            </Box>
            <Space spacing={2} vertical />
            <Box display="flex" justifyContent="space-between" paddingTop={1}>
                <Button text="Back" color="secondary" onClick={props.onBack} />
                <Button text="Complete" variant="contained" color="primary" onClick={props.onComplete} />
            </Box>
        </Box>
    );
}

function EnrollmentMobileBox(props) {
    const {code:courseCode, courseDateStart, courseDateEnd, location, selection, uuid} = props;

    const isSelected = selection && selection.includes(uuid);

    const classDate = () => {
        if(courseDateStart && courseDateEnd) {
            return `${time.format(courseDateStart, 'YYYY/MM/DD')} ~ ${time.format(courseDateEnd, 'YYYY/MM/DD')}`;
        } else {
            return '';
        }
    };

    const backgroundColor = isSelected? '#f0f0f0':'#ffffff';

    return (
        <Box display='flex' flexDirection='column' padding={1} gap={1} marginY={1} borderRadius={3}>
            <Box display={'flex'} flexGrow={'flex-start'}>
                <FormControlLabel control={<Checkbox value={isSelected} onClick={props.onClick}/>} label={'選擇'}/>
            </Box>
            <Typography variant='body1'>{`${i18n.translate('Course No')} : ${courseCode}`}</Typography>
            <Typography variant='body1'>{`課程時間：${classDate()}`}</Typography>
            <Typography variant='body1'>{`課程地點：${code.translate('classLocation', location)}`}</Typography>
        </Box>
    );
}

function EnrollmentStepper(props) {
    const {activeStep, steps=[]} = props;

    return (
        <Stepper activeStep={activeStep} orientation='vertical'>
            {steps.map((label) => (
                <Step key={label}>
                    <StepLabel><Typography>{i18n.translate(label)}</Typography></StepLabel>
                </Step>
            ))}
        </Stepper>
    );
}

export default withDesktop(EnrollmentApplet);